/**
 * Service to store and retrieve item-level settings like price decimal precision.
 * Populated at app startup from the "item" feature preference.
 */
class ItemSettingsServiceClass {
	private maxPriceDecimalPrecision: number = 2;

	/**
	 * Set the maximum number of decimal places to display for prices
	 */
	setMaxPriceDecimalPrecision(value: number): void {
		this.maxPriceDecimalPrecision = value;
	}

	/**
	 * Get the maximum number of decimal places to display for prices.
	 * Defaults to 2 if not explicitly set.
	 */
	getMaxPriceDecimalPrecision(): number {
		return this.maxPriceDecimalPrecision;
	}
}

export const ItemSettingsService = new ItemSettingsServiceClass();
